import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, DateUtilsHttpService, MessageService } from '../../../../core';
import { ClienteAnaliseMercadoFilter } from '../../adapters';
import { ClienteAnaliseMercadoPerspectivaProjetadaListComponent } from '../projetada/list';
import { Meta, MetaTotal, MetaCrudHttpService, MetaFilterTotal, MetaTotalHttpService } from '../../../meta';

@Component({
    selector: 'sgt-cliente-analise-mercado-perspectiva-meta',
    templateUrl: './cliente-analise-mercado-perspectiva-meta.component.html',
    styleUrls: ['./cliente-analise-mercado-perspectiva-meta.component.less']
})
export class ClienteAnaliseMercadoPerspectivaMetaComponent implements OnInit {
    /** Meta selecionada */
    meta: Meta;
    /** Totais da meta selecinada */
    metaTotais: MetaTotal;
    /** Se está carregando a meta */
    isLoadingMeta: boolean;
    /** Se carregou a meta */
    isLoadedMeta: boolean;

    /** Se já verificou se são o mês e ano atuais */
    isMesAtualInitChecked = false;
    /** Se são o mês e ano atuais */
    isMesAtual: boolean;

    @Input() isVisualizacaoModoList: boolean;
    /** Filtro da análise de mercado */
    @Input() filter: ClienteAnaliseMercadoFilter;

    @ViewChild('list') list: ClienteAnaliseMercadoPerspectivaProjetadaListComponent;

    constructor(private dateUtilsHttpService: DateUtilsHttpService,
                private messageService: MessageService,
                private metaCrudHttpService: MetaCrudHttpService,
                private metaTotalHttpService: MetaTotalHttpService) { }

    ngOnInit() {
        // Verificando se é o mês atual
        this.getIsMesAtual()
            .then(() => this.isMesAtualInitChecked = true)
            .catch(() => this.isMesAtualInitChecked = true);
    }

    /** Obtem se o mês do filtro é o mês atual */
    private getIsMesAtual(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.dateUtilsHttpService.isMesAtual(this.filter?.mes, this.filter?.ano)
            .pipe(
                take(1)
            )
            .subscribe(
                response => {
                    this.isMesAtual = response;
                    resolve();
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao verificar se o mês selecionado é o mês atual', error);
                    reject();
                }
            );
        });
    }

    /** Carrega a meta selecionada no filtro */
    private loadMeta(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            // Meta não informada
            if (!this.filter?.idMeta) {
                this.meta = null;
                resolve();
                return;
            }
            // Mesma meta atualmente selecionada
            if (this.meta?.id === this.filter?.idMeta) {
                resolve();
                return;
            }

            // Carregando a meta
            this.meta = null;
            this.metaCrudHttpService.load(this.filter?.idMeta)
                .pipe(
                    take(1)
                )
                .subscribe(
                    meta => {
                        this.meta = meta;
                        setTimeout(() => resolve(), 0);
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao carregar a meta selecionada', error);
                        reject();
                    }
                );
        });
    }

    /** Obtem os totais da empresa e dos representantes na meta selecionada */
    private getTotaisMeta(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            // Meta não informada
            if (!this.filter?.idMeta) {
                this.meta = null;
                resolve();
                return;
            }

            // Criando o filtro
            const filter = new MetaFilterTotal();
            filter.mes = this.filter?.mes;
            filter.ano = this.filter?.ano;
            filter.idsRepresentantes = this.filter?.idsRepresentantes;

            // Obtendo os totais das metas da empresa e dos representantes
            this.metaTotais = null;
            this.metaTotalHttpService.getTotais(this.filter?.idMeta, filter)
                .pipe(
                    take(1)
                )
                .subscribe(
                    totais => {
                        this.metaTotais = totais;
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao obter os totais da meta selecionada', error);
                        reject();
                    }
                );
        });
    }

    private beforeSearch(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.isLoadingMeta = true;
            this.isLoadedMeta = false;

            Promise.all([
                this.loadMeta(),
                this.getTotaisMeta(),
                this.getIsMesAtual()
            ]).then(() => {
                this.isLoadingMeta = false;
                this.isLoadedMeta = true;
                resolve();
            })
            .catch(() => {
                this.isLoadingMeta = false;
                this.isLoadedMeta = false;
                reject();
            });
        });
    }

    search() {
        this.beforeSearch()
            .then(() => {
                if (this.isVisualizacaoModoList) { // List
                    this.list?.search();
                }
            })
            .catch(() => {});
    }
}
